import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import ErrorIllustration from "./ErrorIllustration";
import { Button } from "../../ui/button";
import logo from "../../../assets/images/incruiter-main-logo.svg";

interface NotFoundProps {
  expired?: boolean;
}

const NotFound: React.FC<NotFoundProps> = ({ expired = false }) => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-teal-50">
      <div className="absolute top-8 left-8">
        <img src={logo} alt="Incruiter Logo" className="w-32" />
      </div>

      <div className="min-h-screen flex flex-col items-center justify-center px-4">
        <div className="text-center max-w-2xl mx-auto">
          <div className="mb-6">
            <h1 className="text-6xl md:text-8xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-teal-600 animate-fade-in">
              OOPS!
            </h1>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-2">
              {expired ? "The link has been expired" : "Error 404 - Page not found"}
            </h2>
            {!expired && (
              <p className="text-gray-600 text-lg">We could not find what you were looking for</p>
            )}
          </div>

          <div className="mb-12 animate-scale-in">
            <ErrorIllustration />
          </div>
          {/* 
          <Button 
            onClick={() => window.location.href = "/"}
            className="bg-gradient-to-r from-blue-600 to-teal-600 hover:from-blue-700 hover:to-teal-700 text-white px-8 py-3 rounded-lg font-semibold text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
          >
            Back to Home
          </Button>

          <div className="mt-8 text-sm text-gray-500">
            <p>If you believe this is an error, please contact our support team</p>
          </div> */}
        </div>
      </div>

      <div className="absolute top-20 right-20 w-32 h-32 bg-gradient-to-br from-blue-200 to-teal-200 rounded-full opacity-20 animate-pulse"></div>
      <div className="absolute bottom-20 left-20 w-24 h-24 bg-gradient-to-br from-teal-200 to-blue-200 rounded-full opacity-20 animate-pulse delay-1000"></div>
    </div>
  );
};

export default NotFound;
